import Vue from "vue"
import Router from "vue-router"

const Login = r => require.ensure([], () => r(require("@/page/login")), "login")
const Home = r => require.ensure([], () => r(require("@/page/home")), "home")
const Content = r => require.ensure([], () => r(require("@/page/emailList/content")), "content")
const Index = r => require.ensure([], () => r(require("@/page/emailList/index")), "index")
const Folder = r => require.ensure([], () => r(require("@/page/emailList/folder")), "folder")
const Add = r => require.ensure([], () => r(require("@/page/addEmail/add")), "add")
const AddMeeting = r => require.ensure([], () => r(require("@/page/addEmail/addmeeting")), "addmeeting")
const CalendarView = r => require.ensure([], () => r(require("@/page/calendar/calendarView")), "calendarView")
const set = r => require.ensure([], () => r(require("@/page/mailbox/set")), "set")
const page404 = r => require.ensure([], () => r(require("@/page/page404")), "page404")

Vue.use(Router)

var router = new Router({
	mode: "history",
	routes: [
		// {
		//   path: "/login",
		//   name: "login",
		//   component: Login
		// },
		{
			path: "/",
			name: "home",
			component: Home
		},
		{
			path: "/add",
			name: "emailAdd",
			component: Add
		},
		{
			path: "/folder",
			component: Folder,
			name: "folderList"
		},
		{
			path: "/index",
			component: Index,
			name: "emailList"
		},
		{
			path: "/AddMeeting",
			component: AddMeeting,
			name: "AddMeeting"
		},
		{
			path: "/CalendarView",
			component: CalendarView,
			name: "CalendarView"
		},
		{
			path: "/set",
			component: set,
			name: "set"
		},
		{
			path: "*",
			name: "page404",
			component: page404
		}
	]
})

// 路由控制
router.beforeEach((toRoute, fromRoute, next) => {
	// 非当天的登录取消
	// if (new Date(localStorage.LogTime).getDate() !== new Date(Date()).getDate()) localStorage.clear();
	//	if (toRoute.name !== "login" && !localStorage.Token) {
	//	  next({path: "login"})
	//	} else {
	//  if (localStorage.Account) {
	//    //修改设备id为账户名，并合并登录前的会话
	//    Countly.change_id(localStorage.Account, true)
	//  }
	//  next()
	//	}
	console.log(toRoute, '路由跳转详情-------------------')
	//从外部跳转到邮件详情
	const qureyDetail = toRoute.query
	console.log('获取qureyDetail',qureyDetail)
	if (qureyDetail.open) {
		console.log('写入qureyDetail',qureyDetail)
		window.sessionStorage.setItem('qureyDetail', JSON.stringify(qureyDetail))
	}
	if (localStorage.Token && localStorage.Account) {
		//修改设备id为账户名，并合并登录前的会话
		// console
		// Countly.change_id(localStorage.Account, true)
	} else {
		if (toRoute.path != "/") {
			next("/")
		}
	}
	next()
})

// 路由进入后配置
router.afterEach((to, from) => {
	// 捕捉路由页面变化
	// Countly.track_pageview(to.name)
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js